import React from 'react';
import { Head } from 'react-static';
// images
import podcastImage from './images/a-better-way-to-money-podcast.webp';

export default ({ pageDescription, pageTitle }) => {
  const title = `${pageTitle} | Northwestern Mutual`;
  const description = pageDescription;
  const productName = pageTitle;
  const url = 'https://www.northwesternmutual.com/podcast/';
  const imageAlt = 'Two steaming coffee cups';
  const publisher = 'Northwestern Mutual';
  const imageAbsolutePath = `https://www.northwesternmutual.com${podcastImage}`;

  return (
    <Head>
      <meta name="addsearch-category" content="Planning" />
      <meta name="keywords" content="podcast, Northwestern Mutual podcast, A better way to Money podcast, a better way to money, better way to money, pod cast" />
      <meta name="author" content={publisher} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={publisher} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={podcastImage} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:site" content="@NM_Financial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content="@NM_Financial" />
      <meta name="twitter:creator:id" content="@NM_Financial" />
      <meta name="twitter:image" content={imageAbsolutePath} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "${productName}",
            "description": "${description}",
            "publisher":
            {
              "@type": "FinancialService",
              "name": "${publisher}"
            },
            "url": "${url}"
          }`}
      </script>

      <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "FinancialProduct",
            "name": "${productName}",
            "description": "${description}"
          }`}
      </script>
      <script type="application/ld+json">
        {`{
          "@context": "https://schema.org",
          "@type": "PodcastSeries",
          "name": "${productName}",
          "description": "Do you ever look around and wonder&#8212;is there a better way to be saving, spending and splurging my money&#63; We&#39;ve all been there, and in A Better Way to Money&#174;, from Northwestern Mutual, we&#39;ll help you answer those questions with the help of a roster of expert guests. From saving for your first kid to understanding how retirement savings work, A Better Way to Money&#174; will help you uncover your blind spots and make your money work harder for you.",
          "url": "${url}",
          "publisher": {
            "@type": "Organization",
            "name": "${publisher}"
          }
        }`}
      </script>
    </Head>
  );
};
